export const changeLanguage = (language) => {
    return (dispatch, getState) => {
        dispatch({type:'CHANGE_LANGUAGE', language})
    }
};